module.exports = __webpack_public_path__ + "assets/svg/Icons/32/position-blue-4f2b22.svg";